/* jslint esversion: 6 */
/**
 * Favicon Badge
 *
 * Display a favicon badge on non-live environments to help differentiate tabs.
 *
 * @link http://lab.ejci.net/favico.js/
 *
 * @author Dylan James Wagner
 * @package Baseline
 * @subpackage Scripts
 * @since 2.0.0
 */
const hosts = require('../../../package.json').hosts ?? {
  "live":       "www.dority-manning.com",
  "production": "55v.7cd.mwp.accessdomain.com",
  "staging":    "ago.c3d.mwp.accessdomain.com",
  "lando":      "dority-manning.lndo.site",
};

const Favico = require('favico.js');

function init() {
  const host = window.location.host;

  if (host !== hosts.live) {
    const favico = new Favico({
      animation:  'none',      // slide, fade, pop, popFade, none
      position:   'down',      // down, left, up, upleft
      type:       'rectangle', // circle, rectangle
      bgColor:    '#cc0000',   // #dc0000
      textColor:  '#ffffff',   // #ffffff
      fontFamily: 'monospace', // monospace, serif, sans-serif, Arial, Verdana, Times New Roman ...
      fontStyle:  'bold',      // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
    });

    switch (host) {
      case hosts.production: favico.badge('P'); break;
      case hosts.staging:    favico.badge('S'); break;
      case hosts.lando:      favico.badge('L'); break;
      case hosts.sync:       favico.badge('X'); break; // X because S is used by staging
      default:
        if (host.indexOf('h-') === 0) {
          favico.badge('H');
        }
        else if (host.indexOf('b-') === 0) {
          favico.badge('B');
        }
        else if (host.indexOf('f-') === 0) {
          favico.badge('F');
        }
        else {
          favico.badge('?');
        }
        break;
    }
  }
}

export {init as default};
